import { render, staticRenderFns } from "./EditSection.vue?vue&type=template&id=1b1629c6&scoped=true&"
import script from "./EditSection.vue?vue&type=script&lang=js&"
export * from "./EditSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b1629c6",
  null
  
)

export default component.exports